import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState, useRef } from "react";
import {NavLink, useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

import CustomEditor from "../../../component/CustomEditor"; // Import the centralized CKEditor component
import CustomTagInput from "../../../component/CustomTagInput";


const AddBlog = () => {

        let userInfo = JSON.parse(localStorage.getItem('admin-info'));
        const { id } = useParams();
        const navigate = useNavigate();
        const editorRef = useRef(); // Ref to store the CKEditor instance
        const [title, setTitle] = useState("");
        const [category, setCategory] = useState([]);
        const [tags, setTags] = useState([]);
        const [newdata, setNewdata] = useState({
            title: '', selectedCategory: '0',  imageURL: '', contents: '', tags: ''
        });

        const [selectedImage, setSelectedImage] = useState(null);
        const [previewURL, setPreviewURL] = useState("");
        const [loading, setLoading] = useState(true);


        // Function to Fetch data from API for dropdown
        const fetchData = async (url, setData) => {
            try {
                const response = await fetch(url);
                const data = await response.json();
                setLoading(true);
                setData(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        useEffect(() => {
        
                const fetchDropdowns = async () => {
                    fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindBlogCategoryList', setCategory);
        
                };
                fetchDropdowns();
            }, [id]);


        const handleImageChange = async(e) => {
            const file = e.target.files[0];
            if (file) {
                setSelectedImage(file);
                setPreviewURL(URL.createObjectURL(file)); // Generate preview
            }
        };

        const handleTitleChange = (event) => {
            const newTitle = event.target.value;
                setTitle(newTitle);
                setNewdata(prevData => ({
                ...prevData,
                title: newTitle // Update newdata.title whenever the title changes
        }));
        };

        const onChangehandle = (e) => {
            e.persist();
            
        };
        
    
        const handleEditorChange = (content) => {        
            setNewdata(prevData => ({
                ...prevData,
                exhibitionDetails: content
            }));
        };
    
    
        const handleUpdate = async () => {
            
            
    
        };
    
    
        const handleSubmit = async () => {
           
        debugger;
            try {
                // Step 1: Upload the image first
                const imageFormData = new FormData();
                imageFormData.append("image", selectedImage); // Attach the image file
                
                const uploadResponse = await axios.post('http://localhost:3000/uploadImage/uploadExhibitionImage', imageFormData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
        
                if (uploadResponse.status === 200 && uploadResponse.data.imageUrl) {
                    const imageUrl = uploadResponse.data.imageUrl; // Extract the uploaded image URL
        
                    // Step 2: Save blog data only if the image is successfully uploaded
                    const blogData = {
                        title: title,
                        categoryId: newdata.selectedCategory,
                        contents: newdata.contents,
                        imageUrl: imageUrl, // Save the uploaded image URL
                        tags: tags,
                        createdBy: userInfo.user_id
                    };
        
                    const saveResponse = await axios.post('https://igapi.heuristticminds.com/api/BlogList/Add-SaveBlogDetails', blogData, {
                        headers: { 'Content-Type': 'application/json' }
                    });
        
                    if (saveResponse.status === 200) {
                        // Reset form on success
                        setTitle('');
                        setPreviewURL('');
                        setSelectedImage(null);
                        editorRef.current.setData('');
                        alert("Blog Saved Successfully!");
                        navigate(`/blogAll`);
                    } else {
                        console.error('Error saving blog:', saveResponse.statusText);
                        alert("Failed to save blog data.");
                    }
                } else {
                    console.error('Error uploading image:', uploadResponse.data);
                    alert('Failed to upload image. Blog not saved.');
                }
            } catch (error) {
                console.error('Error:', error);
                alert('Something went wrong! Please try again.');
            }
        };
        
    
        
    
        
    return(

        <>        
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name= {id > 0 ? "Edit Blog Details" : "Add Blog Details"}  icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Add Blogs</div>
                                    <div className="card-body">
                                        <NavLink className="btn btn-primary float-end" to={'/blogAll'}  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        <div className="p-4 pt-2">
                                            

                                            <div className="row">
                                            <div className="col-sm-3 form-group mb-3">
                                                    <label>Category <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <select value={newdata.selectedCategory} onChange={onChangehandle} name="selectedCategory" className="form-control form-select">
                                                                <option value="0">-- Select --</option>
                                                                {
                                                                    category.map((cat) => (
                                                                        <option key={cat.id} value={cat.id}>
                                                                            {cat.category}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                </div>
                                                <div className="col-sm-9 form-group mb-3">
                                                    <label>Title <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <input type="text"
                                                        name="title"
                                                        value={title}
                                                        className="form-control"
                                                        maxLength={100}
                                                        placeholder="Title"
                                                        onChange={handleTitleChange} />
                                                </div>
                                                </div>
                                                
                                                <div className="row">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <label>Content Write-up <span style={{ color: "#ff0000" }}>*</span></label>
                                                    
                                                        <CustomEditor 
                                                                ref={editorRef} 
                                                                value={newdata.contents} 
                                                                onChange={handleEditorChange} 
                                                                placeholder="Enter Exhibition Details / Description"
                                                            /> 
                                                </div>
                                            </div>
                                            
                                               
                                            </div>
                                            <div className="row">
    <div className="col-sm-6 form-group mb-3">
        <label>Upload Title Image <span style={{ color: "#ff0000" }}>*</span></label>
        <input 
            type="file" 
            accept="image/*" 
            className="form-control"
            onChange={handleImageChange} 
        />
    </div>
    <div className="col-sm-6">
        {previewURL && <img src={previewURL} alt="Preview" className="img-thumbnail" width="100" />}
    </div>
</div>
                                            <div className="col-sm-12 form-group mb-3">
                                                <label>Tags</label>  
                                                <CustomTagInput 
                                                    initialTags={Array.isArray(newdata.tags) ? newdata.tags : []}  
                                                    onTagsChange={(updatedTags) => 
                                                    setNewdata(prevData => ({ ...prevData, tags: updatedTags }))
                                                    }
                                                />                                          
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 form-group mt-3">
                                                {id>0 ?
                                                            <button type="button" onClick={handleUpdate} className="btn btn-primary w-50">Update</button>
                                                            :
                                                            <button type="submit"
                                                            onClick={handleSubmit}
                                                                className="btn btn-primary w-50">Submit</button>
                                                        }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                </div>
            </div>
        </>
    );

};
export default AddBlog;